<template>
    <div>
      <v-snackbar v-model="snackbar.visible" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout" :right="snackbar.corner === 'right'" :top="snackbar.position === 'top'">
        <v-layout align-center pr-4>
          <v-icon class="pr-3" dark large>{{ snackbar.icon }}</v-icon>
          <v-layout column>
            <div>
              <strong>{{ snackbar.title }}</strong>
            </div>
            <div>{{ snackbar.text }}</div>
          </v-layout>
        </v-layout>
        <v-btn v-if="snackbar.timeout === 0" icon @click="snackbar.visible = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-snackbar>
      <v-form ref="formEstimate" v-if="languageData.labels">
        <v-progress-circular v-if="dataGetEstimationsFetching"
                             indeterminate
                             color="primary"
        ></v-progress-circular>
          <Instance
            v-for="(child, index) in parents.children"
            v-model="parents.children[index]"
            :key="parents.children[index].id"
            :ref="parents.children[index].id"
            :showVat="showVat()"
            :vatData="vatData"
            :level="0"
            :isMeasurement="isMeasurement"
        >
        </Instance>       
      </v-form>
      <div>
      </div>
      <ModalInfo
          :typeInfo="modalInfo.typeInfo"
          :headModal="modalInfo.head"
          :btn-dis-agree-text="languageData.btnDisAgreeText"
          :btnAgreeText="languageData.btnAgreeText"
          @clicked="hideModalSuccess"
          :show-modal="modalInfo.isShow"
          :text-modal="modalInfo.text">
      </ModalInfo>
      <ModalInfo
          :typeInfo="modalInfoMeasurement.typeInfo"
          :headModal="modalInfoMeasurement.head"
          :btn-dis-agree-text="languageData.btnDisAgreeText"
          :btnAgreeText="languageData.btnAgreeText"
          @clicked="hideModalMeasure"
          :show-modal="modalInfoMeasurement.isShow"
          :text-modal="modalInfoMeasurement.text">
      </ModalInfo>
    </div>
</template>

<style src="./Estimate.scss" lang="scss"></style>

<script type="text/javascript">
import { Child } from "../../helpers/child";
import Instance from "../Instance/Instance";
import { mapActions, mapState } from "vuex";
import eventBus from "../../../../event-bus/eventBus";
import ModalInfo from "../../../../components/ModalInfo/ModalInfo";
import vatSettlement from "../../../Projects/enums/VatSettlement";

export default {
  name: "Estimate",
  props: {
    data: {
      default: null,
      type: Array,
    },
    isOfferForm: Boolean,
    isProjectForm: Boolean,
    isMeasurement: Boolean,
    vatSettlement: [Object, Number],
  },
  components: {
    Instance,
    ModalInfo
  },
  data() {
    return {
      parents: {children: []},
      lowestLevel: 0,
      itemsDeleted: [],
      categoriesDeleted: [],
      parentsDeleted: [],
      detailsDeleted: [],
      snackbar: {
        color: null,
        icon: null,
        mode: null,
        position: null,
        text: null,
        corner: null,
        timeout: 7500,
        title: null,
        visible: false
      },
      estimateFormKey: 0,
      lastItem: null,
      faVatId: vatSettlement.find(vat => vat.name == 'FA_VAT').value,
      isVatPayer: localStorage.getItem("companyIsVatPayer")
    }
  },
  computed: {
    ...mapState("saveEstimate", {
      isSaving: state => state.isSaving,
      modalInfo: state => state.modalInfo
    }),
    ...mapState("saveMeasurement", {
      isSaving: state => state.isSaving,
      modalInfoMeasurement: state => state.modalInfoMeasurement
    }),
    ...mapState("getEstimate", {
      dataGetEstimationsFetching: state => state.dataGetEstimationsFetching,
    }),
    ...mapState("getOffer", {
      dataReceive: state => state.dataReceive
    }),
    ...mapState("getProject", {
      project: state => state.dataReceive
    }),
    ...mapState("getVat", {
      vatData: state => state.vat
    }),
    ...mapState("showEstimationModal", {
      measurementId: state => state.measurementId,
    })
  },
  methods: {
    ...mapActions("saveEstimate", ["storeEstimate", "hideModal"]),
    ...mapActions("saveMeasurement", ["storeMeasurement", "hideModalMeasurement"]),
    ...mapActions("getEstimate", ["getEstimate"]),
    ...mapActions("getVat", ["getVat"]),
    ...mapActions("showEstimationModal", ["updateMeasurementInEdit"]),

    saveEstimate: function() {
      this.$refs.formEstimate.validate();
      let subcategoryCheck = this.isEmpty(this.parents.children).length === 0;
      let measurementCheck = this.validateMeasurement(this.flattenArray(this.parents.children));
      const estimateData = this.parents.children;
      if(this.isMeasurement) {
        if(this.$refs.formEstimate.validate()) {
          
          this.storeMeasurement({
            creds: {
              measurementData: estimateData,
              measurementId: this.measurementId,
              detailsDeleted: this.detailsDeleted,
            }
          });
        } else {
          this.snackbar = {
            color: "error",
            icon: "error",
            mode: "multi-line",
            position: "top",
            corner: 'right',
            title: this.languageData.labels.error_save_measurement,
            text: this.languageData.measurements.error_save_measurement,
            visible: true
          };
        }
      } else {
        if (this.$refs.formEstimate && this.$refs.formEstimate.validate() && subcategoryCheck) {
          this.storeEstimate({
            creds: {
              estimateData: estimateData,
              parentsDeleted: this.parentsDeleted,
              categoriesDeleted: this.categoriesDeleted,
              itemsDeleted: this.itemsDeleted,
            }
          });
        } else {
          this.snackbar = {
            color: "error",
            icon: "error",
            mode: "multi-line",
            position: "top",
            corner: 'right',
            title: this.languageData.labels.save_estimation,
            text: subcategoryCheck === false ? this.languageData.labels.error_save_estimation_subcategory : this.languageData.labels.error_save_estimation,
            visible: true
          };
        }
      }
    },
    isEmpty(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.isEmpty(children) : children)
      return flattenArr.filter((e) => {
        return e.visibleInput === false && e.children.length === 0; // determine if estimation has visible inputs
      });
    },
    flattenArray(arr) {
      let children = [];
      const flattenMembers = arr.map(m => {
        if (m.children && m.children.length) {
          children = [...children, ...m.children];
        }
        return m;
      });
      let flattenArr = flattenMembers.concat(children.length ? this.flattenArray(children) : children)

      return flattenArr.filter((e) => {
        return e.visibleInput === true;
      });
    },
    validateMeasurement(arr) {
      for (const el of arr) {
        if(Object.prototype.hasOwnProperty.call(el, 'measurementDetails') && el.measurementDetails.length > 0) {
          return (el.measurementDetails.every(e => e.value !== null && e.description !== '' && e.FSF !== undefined && e.FSF !== null))
        }
      }
    },
    hideModalSuccess: function() {
      this.hideModal();
    },
    hideModalMeasure: function() {
      this.hideModalMeasurement();
    },
    addCategory() {
      let newChild = new Child(null, false);
      this.parents.children.push(newChild);
      eventBus.$emit('categoryAdded', newChild.id);
    },
    addValues(data, num = 1) {
      const locale = 'en-US';
      const options = {minimumIntegerDigits: 2, useGrouping:false};
      let arr = data;
      for(let i = 0; i < arr.length; i++) {

        if(num === 1) {
          arr[i].number = (i + num).toLocaleString(locale, options);
        } else {
          if(arr[i].visibleInput) {
            arr[i].number = arr[i].number ? arr[i].number : num + (i+1);
          } else {
            arr[i].number = arr[i].number ? arr[i].number : num + (i+1).toLocaleString(locale, options);
          }
        }
        if(arr[i].children.length > 0) {
          this.addValues(arr[i].children, arr[i].number + '.');
        }
      }
    },
    showVat() {
        if(this.vatSettlement === undefined && !this.isOfferForm) {
          return this.project.showVat;
        } else if (this.isOfferForm) {
          return this.isVatPayer === 'false' ? false : true;
        } else {
          return typeof(this.vatSettlement) === 'object' ? this.vatSettlement.name === 'FA_VAT' : this.vatSettlement === 2;
        }
    }
  },
  mounted() {
    if(!this.isOfferForm && !this.isProjectForm) {
      if(this.measurementId) {
        this.getEstimate({id: null, measurementId: this.measurementId})
      } else {
        this.getEstimate({id: null});
      }
    }
    this.getVat();
    if(this.data !== null) {
      this.parents.children = this.data;
    }
    if(this.parents.children.length === 0) {
      this.parents.children.push(new Child(null, false));
      this.addValues(this.parents.children);
    }
    eventBus.$on("getEstimateSuccess", (categories) => {
      if(categories.length === 0) {
        eventBus.$emit('refreshEstimationNumbers');
      } else {
        this.parents.children = categories;
      }
      eventBus.$emit('assignVatEstimate');
    });

    eventBus.$on("getMeasurementSuccess", (categories) => {
      if(categories.length === 0) {
        eventBus.$emit('refreshEstimationNumbers');
      } else {
        this.parents.children = categories;
      }
    });

    eventBus.$on("deleteParent", (parent) => {
      this.parentsDeleted.push(parent.id);
      this.parents.children.splice(this.parents.children.indexOf(parent), 1)
    });
    eventBus.$on('deleteItem', (itemId) => {
      this.itemsDeleted.push(itemId);
    });
    eventBus.$on('deleteDetail', (itemId) => {
      this.detailsDeleted.push(itemId);
      if(this.detailsDeleted.length === 0) {
        this.updateMeasurementInEdit(false);
      }
    })
    eventBus.$on('deleteCategory', (categoryId) => {
      this.categoriesDeleted.push(categoryId);
    })
    eventBus.$on('addCategory', () => {
      this.addCategory();
      this.addValues(this.parents.children);
    });
    eventBus.$on('saveEstimate', () => {
      this.saveEstimate();
      this.addValues(this.parents.children);
      this.parentsDeleted = [];
      this.categoryDeleted = [];
      this.itemsDeleted = [];
    });
    eventBus.$on('saveOfferEstimate', () => {
      let subcatCheck = this.isEmpty(this.parents.children).length === 0;
      if(this.$refs.formEstimate.validate() && subcatCheck) {
        eventBus.$emit('offerEstimatePrepare', {
          estimate: this.parents.children,
          parentsDeleted: this.parentsDeleted,
          categoriesDeleted: this.categoriesDeleted,
          itemsDeleted: this.itemsDeleted,
        });
      } else {
      this.snackbar = {
        color: "error",
        icon: "error",
        mode: "multi-line",
        position: "top",
        corner: 'right',
        title: this.languageData.labels.save_estimation,
        text: subcatCheck === false ? this.languageData.labels.error_save_estimation_subcategory : this.languageData.labels.error_save_estimation,
        visible: true
      };
    }
    });
    eventBus.$on('saveProjectEstimate', () => {
      let subcatCheck = this.isEmpty(this.parents.children).length === 0;
      if(this.$refs.formEstimate.validate() && subcatCheck) {
        eventBus.$emit('projectEstimatePrepare', this.parents.children);
      } else {
        this.snackbar = {
          color: "error",
          icon: "error",
          mode: "multi-line",
          position: "top",
          corner: 'right',
          title: this.languageData.labels.save_estimation,
          text: subcatCheck === false ? this.languageData.labels.error_save_estimation_subcategory : this.languageData.labels.error_save_estimation,
          visible: true
        };
      }
    });

    eventBus.$on('refreshEstimationNumbers', () => {
      this.addValues(this.parents.children);
    });

    eventBus.$on('categoryAdded', (id) => {
      this.$nextTick(() => {
        this.$refs[id][0].$el.scrollIntoView({behavior: 'smooth'});
      })
    });

    eventBus.$on('updateNumbers', () => {
      this.addValues(this.parents.children)
    });

    eventBus.$on('getMeasurementEvent', (id) => {
      let data = {id: null, measurementId: id}
      this.getEstimate(data)
    });

    eventBus.$on('saveEstimateSuccess', () => {
      eventBus.$emit('enableCreateMeasurement');
      this.getEstimate({id: null});
    });
  },
  beforeDestroy() {
    eventBus.$off('addCategory');
    eventBus.$off('categoryAdded');
    eventBus.$off('deleteCategory');
    eventBus.$off('deleteParent');
    eventBus.$off('deleteItem');
    eventBus.$off('deleteDetail');
    eventBus.$off('saveOfferEstimate');
    eventBus.$off('saveProjectEstimate');
    eventBus.$off('saveEstimate');
  }

}
</script>